import auth from './auth'
import theme from './theme'
import locale from './locale'
import build from './build'
export default {
  auth,
  theme,
  locale,
  build,
}